<template>
  <div>
    <epi-modal :opening-event-name="openingEventName" title="이용권 추가">
      <template v-slot:offcanvas></template>
      <template v-slot:header-menu></template>
      <template v-slot:body>
        <label class="form-label">고객 이용권 추가</label>

        <div class="row align-items-center">
          <div class="col-3">이용권</div>
          <div class="col-9">
            <epi-select placeholder="이용권 선택" />
          </div>

          <div class="mb-3"></div>

          <div class="col-3">결제방법</div>
          <div class="col-9">
            <epi-select placeholder="결제방법 선택" />
          </div>

          <div class="mb-3"></div>

          <div class="col-3">결제일자</div>
          <div class="col-9">
            <epi-date-picker />
          </div>

          <div class="mb-3"></div>

          <div class="col-3">회차</div>
          <div class="col-9">
            <input
              type="number"
              class="form-control"
              placeholder="회차를 입력해주세요"
            />
          </div>

          <div class="mb-3"></div>

          <div class="col-3">금액</div>
          <div class="col-9">
            <input
              type="text"
              class="form-control"
              placeholder="금액을 입력해주세요"
               @keyup="inputNumberFormat()" 
              v-model="price" 
            />
          </div>
        </div>

        <div class="d-flex justify-content-end">
          <button class="btn btn-light">추가</button>
        </div>

        <hr class="my-0 py-0" />

        <label class="form-label">이용권 목록</label>

        <div class="accordion" id="voucherHistoryAccordion">
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button
                class="accordion-button"
                data-bs-toggle="collapse"
                data-bs-target="#voucherHistory1"
              >
                <div
                  class="d-flex justify-content-between align-items-center w-100"
                >
                  <span> 4회기 이용권(개인) 4 / 4</span>
                  <i class="bi bi-trash me-3 text-danger"></i>
                </div>
              </button>
            </h2>
            <div
              class="accordion-collapse collapse show"
              id="voucherHistory1"
              data-bs-parent="#voucherHistoryAccordion"
            >
              <div class="accordion-body">
                <p>
                  2022-08-16 || 13:00 || 4회기 이용권 [ 3 / 4 ]
                  <br />
                  2022-08-10 || 10:30 || 4회기 이용권 [ 2 / 4 ]
                  <br />
                  2022-08-08 || 09:30 || 4회기 이용권 [ 1 / 4 ]
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="d-flex w-100 justify-content-end align-items-center">
          <div class="hstack gap-2">
            <button class="btn btn-light" data-bs-dismiss="modal">확인</button>
          </div>
        </div>
      </template>
    </epi-modal>
  </div>
</template>

<script>
import { EventName } from "@/const";

export default {
  name: "VoucherAddModal",
  data() {
    return {
      openingEventName: EventName.VoucherAddModalOpening,
      price : '',
    };
  },
  mounted() {},
  methods:{
    inputNumberFormat() {
      const price = this.price;
      const uncomma = this.uncomma(price);
      this.price = this.comma(uncomma);
    },
    comma(str) {
      str = String(str);
      return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
    },
    uncomma(str) {
      str = String(str);
      return str.replace(/[^\d]+/g, '');
    }
  }
};
</script>
<style lang="stylus" scope>
:root
  --bs-body-font-weight: normal;

</style>